import { useRef, useEffect } from 'react';
import { useAnimation } from 'framer-motion';
import { useIntersectionObserver } from 'usehooks-ts';

import { asIntersectionObserverRef } from '../../../utils/hooks';
import Section from '../../../uiParts/Sections/Section/Section';
import VerticalBorder from '../../../uiParts/VerticalBorder/VerticalBorder';
import BlankLinkHoverBtn from '../../../uiParts/Buttons/BlankLinkHoverBtn';

import styles from './CVPdfSection.module.css';

export default function CVPdfSection() {
  const control = useAnimation();
  const ref = useRef<HTMLElement>(null);
  const entry = useIntersectionObserver(asIntersectionObserverRef(ref), {
    root: null,
    rootMargin: '20px',
    threshold: 0.5,
    freezeOnceVisible: true,
  });

  const isVisible = !!entry?.isIntersecting;

  useEffect(() => {
    control.start({
      height: '50px',
      transition: {
        duration: 1,
      },
    });
  }, [isVisible, control]);

  return (
    <Section ref={ref} className={styles.section}>
      <VerticalBorder control={control} />
      <BlankLinkHoverBtn text="View CV" link="/resources/pdf/cv-daisuke.pdf" isArrow={true} />
    </Section>
  );
}
